import { Button, DialogContent, InputAdornment, TextField, Grid2 } from '@mui/material';
import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Product } from '../types';
import { DialogHeader } from '../../../components/DialogHeader';
import { Currencies, CURRENCY_SYMBOLS } from '../../../types';
import { useGetCompanyVendorProfileQuery } from '../../../services/vendorProfile';
import useAuth from '../../../components/Auth';

interface Props {
    onSubmit: (payload: Partial<Product>) => void;
    onClose: () => void;
	open: boolean;
    product: Product;
}

const EditProductDialog = ({ onSubmit, onClose, open, product }: Props) => {
	const [formData, setFormData] = useState<Partial<Product>>({});
	const {userProfile} = useAuth();
	const {data: vendorProfile} = useGetCompanyVendorProfileQuery(undefined, {skip: !userProfile});
	const currencySymbol = CURRENCY_SYMBOLS[vendorProfile?.currency as Currencies];

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.target as HTMLFormElement);
		onSubmit(Object.fromEntries(formData) as Partial<Product>);
	};

	useEffect(() => {
		if (product) {
			setFormData(product);
		}
	}, [product]);

	return <Dialog open={open} fullWidth onClose={onClose}>
		<DialogHeader title={formData.name ?? ''} imgUrl={formData.imgUrl} onClose={onClose} />
		<DialogContent>
			<form onSubmit={handleSubmit}>
				<Grid2 container spacing={2}>
					<Grid2>
						<TextField disabled fullWidth required autoComplete='off' label='SKU' name='sku' defaultValue={formData.sku} />
					</Grid2>
					<Grid2>
						<TextField autoComplete='off' label='Image URL' name='imgUrl' defaultValue={formData.imgUrl ?? ''} />
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth required autoComplete='off' label='Name' name='name' defaultValue={formData.name ?? ''} />
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth multiline rows={3} autoComplete='off' label='Description' name='description' defaultValue={formData.description ?? ''} />
					</Grid2>
					<Grid2>
						<TextField required autoComplete='off' label='Unit of measure' name='uom' defaultValue={formData.uom ?? ''} />
					</Grid2>
					<Grid2>
						<TextField disabled={formData.isBundle} type='number' autoComplete='off' label='Price per unit' name='pricePerUnit' defaultValue={formData.pricePerUnit ?? ''} inputProps={{ step: 'any' }} slotProps={{
							input: {
								endAdornment: <InputAdornment position="end">{currencySymbol}</InputAdornment>,
							},
						}}/>
					</Grid2>
					<Grid2 size={12}>
						<TextField fullWidth multiline rows={3} autoComplete='off' label='Notes (internal use only)' name='notes' defaultValue={formData.notes ?? ''} />
					</Grid2>
					<Grid2 size={12}>
						<Button type='submit' variant='contained'>Save</Button>
					</Grid2>
				</Grid2>
			</form>
		</DialogContent>
	</Dialog>;   
};

export default EditProductDialog;
